import React, { useState, useEffect } from 'react';

import { Modal } from 'bootstrap';

import { instructionSteps } from "data/certifications/epstInstruction";
import MicRecorderPreview from 'components/audio-recoder/MicRecorderPreview';

const ExamInstructionsModal = ({ onStart }) => {
	const [step, setStep] = useState(0);
    const [confirmed, setConfirmed] = useState(false);

	useEffect(() => {
		let modal = new Modal(document.getElementById('examInstructionsModal'));
		modal.show();
	}, []);

	const handleNext = () => {
		if (step === instructionSteps.length - 1) {
			document.getElementById('examInstructionsModal')?.classList.remove('show');
            document.querySelector('.modal-backdrop')?.remove();
            document.getElementById('examInstructionsModal').style.display = 'none';
            document.body.style.overflow = 'auto';
			onStart();
		} else {
			setStep(prev => prev + 1);
		}
	};

	const { title, description, button, image, type, audioSrc } = instructionSteps[step];

	return (
		<div
			className="modal fade"
			id="examInstructionsModal"
			tabIndex="-1"
			aria-hidden="true"
			data-bs-backdrop="static"
			data-bs-keyboard="false"
		>
			<div className="modal-dialog modal-lg">
				<div className="modal-content">
					<div className="modal-header">
						<h5 className="modal-title">{title}</h5>
					</div>
					<div className="modal-body">
						<pre style={{ whiteSpace: 'pre-wrap' }}>{description}</pre>
                        <br/>
                        {image && (
							<div className="text-center mb-3">
								<img src={image} alt={title} className="img-fluid" style={{ maxHeight: 180 }} />
							</div>
						)}
						
                        
                        {/* Verificación de audio */}
                        {type === "audio-test" && audioSrc && (
                            <div className="text-center my-3">
                                <audio controls>
                                    <source src={audioSrc} type="audio/mpeg" />
                                    Tu navegador no soporta audio.
                                </audio>
                            </div>
                        )}

                        {/* Verificación de micrófono */}
                        {type === "mic-test" && (
                            <MicRecorderPreview onConfirm={() => setConfirmed(true)} />
                        )}
					</div>
					<div className="modal-footer">
						<button className="btn btn-primary" onClick={handleNext}>
							{button}
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ExamInstructionsModal;